import cascaderScroll from "./cascaderScroll";
import permission from "./permission";

export default {
	install(Vue) {
		Vue.directive(permission.name, permission.directive);
		Vue.directive(cascaderScroll.name, cascaderScroll.directive);
	}
};
